export const START_PROCCESS_BLOG = "START_PROCCESS_BLOG";
export const END_PROCCESS_BLOG = "END_PROCCESS_BLOG";
export const SET_ALL_BLOGS = "SET_ALL_BLOGS";
export const GET_DATA_FAIL_BLOG = "GET_DATA_FAIL_BLOG";
export const DELETE_BLOG = "DELETE_BLOG";
